import apiClient from './apiClient';
import {ResponseDto} from "./ResponseDto";
import {MemberWalletTypes} from "../types/member/member.wallet.types";
import CompanyInfo from "../interface/CompanyInfo";
import {Shop, ShopListParams} from '../interface/Shop';
import {VerifyPasswordDto} from "./authApi";
import {AuthBackDepositorTypes, BankAccountCheckTypes} from "../types/common/bank.account.types";


export interface AccountData {
    id: {
        coCode: string;
        coGroup: number;
    }
    coName: string; // bankName
}

export interface AddressData {
    coCode: string;
    coName: string;
    upperCoCode: string;
}


export const getBankList = () =>
    apiClient.get<ResponseDto<AccountData[]>>("/api/front/auth/banks");

export const getAreaList = () =>
    apiClient.get<ResponseDto<AddressData[]>>('/api/front/auth/areas');

export const findAreaList = (upperCoCode: string) =>
    apiClient.get<ResponseDto<AddressData[]>>('/api/front/auth/areas/sub', {
        params: {upperCoCode}
    });

export const getPreferredArea = () =>
    apiClient.get<ResponseDto<any>>('/api/front/member/preferred-area');

export const updateArea = (preferredAreaMajor: string, preferredAreaMinor: string) =>
    apiClient.put<ResponseDto<AddressData[]>>('/api/front/member/updateArea', {
        preferredAreaMajor,
        preferredAreaMinor
    });

export const validateId = (id: string) =>
    apiClient.get<ResponseDto<AddressData[]>>('/api/front/auth/validate-id', {
        params: {id}
    });

export const getNationalityList = () =>
    apiClient.get<ResponseDto<AddressData[]>>('/api/front/common/getNationalityList');


export const getMemberWalletBalance = () =>
    apiClient.get<ResponseDto<MemberWalletTypes>>('/api/front/member/getMemberWalletBalance');


export const getCompanyInfo = () =>
    apiClient.get<ResponseDto<CompanyInfo>>('/api/front/common/company-info');

// 내주변
export const getShopList = (params: ShopListParams) =>
    apiClient.get<Shop[]>('/api/front/common/get-shop-list', {params});

export const getShopDetail = (shopId: number) =>
    apiClient.get<Shop>(`/api/front/common/get-shop-detail/${shopId}`);

export const verifyPaymentPassword = (data: VerifyPasswordDto) =>
    apiClient.post<ResponseDto<boolean>>(`/api/front/common/verify-payment-password`, data);


export interface Banner {
    seq: number;
    bannerCode: string;
    section: string;
    bannerName: string;
    displayYn: boolean;
    startAt: string | null;
    endAt: string | null;
    sortOrder: number;
    linkUrl: string;
    bannerImageUrl: string;
    regDate: string;
    updDate: string;
}

export interface BannerListParams {
    section?: string;
    displayYn?: boolean;
}

/**
 * 배너 목록 조회 (노출중인 배너만)
 */
export const getBannerList = (params?: BannerListParams) =>
    apiClient.get<ResponseDto<Banner[]>>('/api/front/common/banners', {params});

/**
 * 특정 섹션의 배너 목록 조회
 */
export const getBannersBySection = (section: string) =>
    apiClient.get<ResponseDto<Banner[]>>(`/api/front/common/banners/section/${section}`);


export const checkDepositorAndSaveAccount = (data: BankAccountCheckTypes) =>
    apiClient.post<ResponseDto<any>>(`/api/front/common/checkDepositorAndSaveAccount`, data);


export interface PopupFile {
    seq: number;
    fileName: string;
    fileSize: number;
    filePath: string;
}

export interface Popup {
    id: number;
    popupCode: string;
    section: string;
    popupName: string;
    displayYn: boolean;
    displayType: string;
    startAt: string | null;
    endAt: string | null;
    hideTodayEnabled: boolean;
    target: string | null;
    linkUrl: string | null;
    sortOrder: number;
    popupImageUrl: string | null;
    fileList: PopupFile[] | null;
}

export const getPopupsBySection = (section: string) =>
    apiClient.get<ResponseDto<Popup[]>>(`/api/front/common/popups/section/${section}`);




export const changePaymentPassword = (data: { paymentPassword: string }) =>
    apiClient.put<ResponseDto<boolean>>(`/api/front/common/change-payment-password`, data);

export const verifyLoginPassword = (data: { password: string }) =>
    apiClient.post<ResponseDto<boolean>>(`/api/front/common/verify-login-password`, data);


